<template lang="pug">
  validation-provider(
    :name="field.name"
    :rules="fieldRules"
    :disabled="fieldProps.disabled"
    v-slot="{ errors }"
  )
    component(
      v-model="fieldValue"
      v-bind="fieldProps"
      :is="field.component"
      :error-messages="errors"
    )
</template>

<script>
import get from 'lodash/get';

export default {
  inject: ['getFormData'],
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formData() {
      return this.getFormData();
    },
    fieldRules() {
      const { field } = this;
      return field.rules || '';
    },
    fieldRulesObj() {
      const { fieldRules } = this;
      let rules = fieldRules;

      if (typeof rules === 'object') {
        return rules;
      }

      if (typeof rules === 'string') {
        rules = fieldRules.split('|').filter(Boolean);
      }

      return Object.values(rules)
        .reduce((acc, rule) => {
          let output = true;
          const [name, val] = rule.split(':');

          if (typeof val === 'string') {
            const args = val.split(',');
            output = args.length > 1 ? args : args.at(0);
          }

          return { ...acc, [name]: output };
        }, {});
    },
    isRequired() {
      const { fieldRulesObj } = this;
      return Object.keys(fieldRulesObj)
        .some((rule) => rule.startsWith('required'));
    },
    fieldProps() {
      const { field, fieldRulesObj, isRequired } = this;

      return {
        label: field.label,
        disabled: false,
        required: isRequired,
        ...field.props || {},
        ...field.rulesProps?.(fieldRulesObj),
      };
    },
    fieldValue: {
      get() {
        const { formData, field } = this;
        return get(formData, field.value);
      },
      set(value) {
        const path = this.field.value.split('.');
        let target = this.formData;

        path.slice(0, -1).forEach((key) => {
          if (!target[key]) this.$set(target, key, {});
          target = target[key];
        });

        this.$set(target, path[path.length - 1], value);
      },
    },
  },
};
</script>
